import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import Page from '../shared/components/PageComponent';
import Layout from '../shared/components/LayoutComponent';
import { FullPageSpinner } from '../lib';
import InputBox from '../shared/components/InputBox';
import umlauteErsetzen from "../shared/functions/umlauteErsetzen";
import { useSessionStorage } from '../../utils/hooks';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
import {
  Paper,
  Typography,
  Table,
  Hidden,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Button,
  TableHead,
  Grid,
  Box,
} from "@mui/material";
import MessageBox from '../shared/components/MessageBox';
import TextField from "@mui/material/TextField";
function ToDoInvite() {
  const { t } = useTranslation();
  let { inviteKey } = useParams();
  const [questions, setQuestions] = useState([]);
  const [accessToken,] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [isLoading, setIsLoading] = useState(false);
  const [daten, setDaten] = useState([])
  const [msgBox, setMsgBox] = useState("")
  const [text, setText] = useState("")
  const [absageGrund, setAbsageGrund] = useState("")
  const [isSending, setIsSending] = useState(false);
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();
  const navigate = useNavigate();

  const loadQuestions = () => {
    const payload = {
      "statement": "INVITE_READ",
      "aufgabe": inviteKey,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'aufgaben', payload, headers, questionsCb);
  }
  useEffect(() => {
    loadQuestions();
    // eslint-disable-next-line
  }, [])

  const messageBoxResult = (antwort) => {
    if (antwort === "YES") {
      setMsgBox("")
      const payload = {
        "statement": "INVITE_ANSWER",
        "aufgabe": inviteKey,
        "antwort": msgBox,
        "grund": absageGrund,
      }
      const headers = {
        "Authorization": "Bearer " + accessToken,
      }
      apiRequest('POST', 'aufgaben', payload, headers, resultCb, errorCb);


    } else {
      setMsgBox("")
    }


  }
  const veranstaltungAction = (antwort) => {
    var text = ""
    if (antwort === "3") {
      if (absageGrund === "") {
        text = "Sind Sie sicher dass Sie ohne Grund absagen wollen ?"
        setMsgBox(antwort)
        setText(text)
      } else {
        text = "Sind Sie sicher dass Sie absagen wollen ?"
        setMsgBox(antwort)
        setText(text)
      }
    }else {
      const payload = {
        "statement": "INVITE_ANSWER",
        "aufgabe": inviteKey,
        "antwort": antwort,
        "grund": absageGrund,
      }
      const headers = {
        "Authorization": "Bearer " + accessToken,
      }
      apiRequest('POST', 'aufgaben', payload, headers, resultCb, errorCb);
    }
  }

  const resultCb = (response) => {
    setIsSending(false);
    setIsLoading(false)
    if (response.status === 200) {
      showSuccessMessage(t("Ihre Eingaben wurden gespeichert"));
      navigate(-1);
    } else {
      showErrorMessage(response.data.message);
    }
  }
  const errorCb = () => {
    setIsSending(false);
    showErrorMessage(t("Änderung konnte nicht gesendet werden. Bitte versuchen Sie es erneut."));
  }
  const questionsCb = (response) => {
    if (response.status === 200) {

      setDaten(response.data.daten);

    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const cancel = () => {
    navigate(-1)
  }
  if (isLoading) {
    return <LoadingComponent />
  }
  return (
    <Page>
      <Layout>
        <Box p={2}>
          <Hidden smDown>
            <Typography color="primary" variant="h5">
              {daten.bez}
            </Typography>

            <Box p={2}>
              <Grid container justifyContent="center" spacing={1}>
                <Grid item xs={12} sm={10} lg={8}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}
                  >

                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        label={t("Organisator")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        disabled
                        value={daten.organisator}
                      ></TextField>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        label={t("Beschreibung")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        disabled
                        value={daten.bez}
                      ></TextField>
                    </Grid>
                    {daten?.eintaegig === "1" ?
                      <>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            label={t("Datum")}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                            disabled
                            value={daten.vonDat + " (" + t("Eintägig") + ")"}
                          ></TextField>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            label={t("Uhrzeit")}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                            disabled
                            value={daten.vonZeit + " - " + daten.bisZeit}
                          ></TextField>
                        </Grid>
                      </>
                      : <><Grid item xs={12}><TextField
                        variant="outlined"
                        label={t("Von")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        disabled
                        value={daten.vonDat + "  " + daten.vonZeit}
                      ></TextField>
                      </Grid>
                        <Grid item xs={12}><TextField
                          variant="outlined"
                          label={t("Bis")}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          disabled
                          value={daten.bisDat + "  " + daten.bisZeit}
                        ></TextField>
                        </Grid>
                      </>}
                    <Grid item xs={12}>
                      {daten?.beschreibung !== "" &&
                        <>                     <Typography variant='h6'>
                          {t("Beschreibung: ")}
                        </Typography>
                          <Typography align='left'>
                            {daten?.beschreibung?.replace(/<[^>]*>/g, "")}
                          </Typography>
                        </>
                      }
                    </Grid>
                    <Grid item xs={12}>

                      <>
                        <TextField
                          variant="outlined"
                          label={t("Absagegrund bei Absage")}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          onChange={(e) => setAbsageGrund(e.target.value)}
                          value={absageGrund}
                        ></TextField>
                      </>

                    </Grid>
                    <Grid item xs={6}>
                      <Button fullWidth variant='contained' onClick={() => veranstaltungAction("3")}>Ablehnen</Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button fullWidth variant='contained' onClick={() => veranstaltungAction("2")}>Annehmen</Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Hidden>
          <Hidden smUp>
            <Typography color="primary" variant="h5">
              {daten.bez}
            </Typography>

            <Box p={2}>
              <Grid container justifyContent="center" spacing={1}>
                <Grid item xs={12} sm={10} lg={8}>
                  <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}
                  >

                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        label={t("Organisator")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        disabled
                        value={daten.organisator}
                      ></TextField>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        label={t("Beschreibung")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        disabled
                        value={daten.bez}
                      ></TextField>
                    </Grid>
                    {daten?.eintaegig === "1" ?
                      <>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            label={t("Datum")}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                            disabled
                            value={daten.vonDat + " (" + t("Eintägig") + ")"}
                          ></TextField>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            label={t("Uhrzeit")}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                            disabled
                            value={daten.vonZeit + " - " + daten.bisZeit}
                          ></TextField>
                        </Grid>
                      </>
                      : <><Grid item xs={12}><TextField
                        variant="outlined"
                        label={t("Von")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        disabled
                        value={daten.vonDat + "  " + daten.vonZeit}
                      ></TextField>
                      </Grid>
                        <Grid item xs={12}><TextField
                          variant="outlined"
                          label={t("Bis")}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          disabled
                          value={daten.bisDat + "  " + daten.bisZeit}
                        ></TextField>
                        </Grid>
                      </>}
                    <Grid item xs={12}>
                      {daten?.beschreibung !== "" &&
                        <>                     <Typography variant='h6'>
                          {t("Beschreibung: ")}
                        </Typography>
                          <Typography align='left'>
                            {daten?.beschreibung?.replace(/<[^>]*>/g, "")}
                          </Typography>
                        </>
                      }
                    </Grid>
                    <Grid item xs={12}>

                      <>
                        <TextField
                          variant="outlined"
                          label={t("Absagegrund bei Absage")}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          onChange={(e) => setAbsageGrund(e.target.value)}
                          value={absageGrund}
                        ></TextField>
                      </>

                    </Grid>
                    <Grid item xs={6}>
                      <Button fullWidth variant='contained' onClick={() => veranstaltungAction("3")}>Ablehnen</Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button fullWidth variant='contained' onClick={() => veranstaltungAction("2")}>Annehmen</Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Hidden>

        </Box>
      </Layout >
      {isSending && <FullPageSpinner />
      }
      <MessageBox
        open={msgBox !== ""}
        handleResponse={messageBoxResult}
        buttons="YESNO"
        text={t(text)}
        title={t("Hinweis")}
        onClose={() => setMsgBox("")}
      />
    </Page >
  )
}
export default ToDoInvite;
